const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/idea-management')({
  beforeLoad: async ({
    context: {
      flags
    }
  }) => {
    if (!flags.fimIdeaManagerEnabled) {
      throw notFound();
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner,
  staticData: {
    topNav: {
      title: i18n.t('ideaManagement.ideaManagement')
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t('ideaManagement.ideaManagement')
  })
});